module.exports = __webpack_public_path__ + "media/images/advance-7efe7a0c3024e22e2239c0d6d8b9b0c0.svg";